/** Client-safe helpers for official CertLynx Community forum posts. */

export const OFFICIAL_FORUM_USERNAME = "certlynx-community";

export function isOfficialForumAuthor(
  author?: {
    isOfficial?: boolean | null;
    username?: string | null;
  } | null,
): boolean {
  return Boolean(author?.isOfficial) || author?.username === OFFICIAL_FORUM_USERNAME;
}

export type ForumListHeadline = {
  description: string;
  /** True only when the topic list is actually empty (no member or official cards). */
  showFirstPostCta: boolean;
};

/**
 * Copy for every `/forums/[category]` page (exam rooms and field umbrellas).
 * Official CertLynx starter threads count as existing topics — never show
 * "new community / be the first" while those cards are on screen.
 */
export function forumListHeadline(input: {
  loading: boolean;
  searchActive: boolean;
  categoryName: string;
  sortLabel: string;
  visibleMemberCount: number;
  visibleOfficialCount: number;
}): ForumListHeadline {
  const visible = input.visibleMemberCount + input.visibleOfficialCount;
  if (input.loading) {
    return { description: "Loading…", showFirstPostCta: false };
  }
  if (input.searchActive && visible === 0) {
    return { description: "No matching topics", showFirstPostCta: false };
  }
  if (input.visibleMemberCount > 0) {
    const n = input.visibleMemberCount;
    return {
      description: `${n} discussion${n !== 1 ? "s" : ""} • Sorted by ${input.sortLabel}`,
      showFirstPostCta: false,
    };
  }
  if (input.visibleOfficialCount > 0) {
    return {
      description:
        input.visibleOfficialCount === 1
          ? "Jump into the starter thread or ask a question."
          : "Jump into a starter thread or ask a question.",
      showFirstPostCta: false,
    };
  }
  return {
    description: `New community — your question can be the first in ${input.categoryName}.`,
    showFirstPostCta: !input.searchActive,
  };
}
